import React from 'react';
import classNames from 'classnames';

import ButtonClean from '~/components/ButtonClean';
import Image from '~/components/Image';

import { IFilter } from '~/interfaces/IFilter';
import { useSlotsContext } from '~/redux/slices/slotsFilters';

import styles from './FilterButton.module.scss';

type TButtonProps = {
  filter: IFilter;
};

const FilterButton: React.FC<TButtonProps> = ({
  filter: { _id, filterTitle, filterIcon },
}) => {
  const { useFilter } = useSlotsContext();
  const [checked, toggleFilter] = useFilter(_id);

  return (
    <ButtonClean
      className={classNames(styles.button, {
        [styles.active]: checked,
      })}
      onClick={toggleFilter}
    >
      <Image
        className={styles.icon}
        path={filterIcon}
        alt={filterTitle}
      />
      <div>{filterTitle}</div>
    </ButtonClean>
  );
};

export default FilterButton;
